const weekdaySort = (a: any, b: any) => {
    'use strict';
    const weekdayOrder = [1, 2, 3, 4, 5, 6, 0];
    return weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b);
};

export default weekdaySort;
